// import React, { useState, useEffect } from "react";
// import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaShieldAlt } from "react-icons/fa";
// import "./PrivacyPolicy.css";
// import Footer from "../pages/main/footer";
// import Navbar from "../components/Navbar";
// import api from "../services/httpService";

// const PrivacyPolicy = () => {
//   const [privacyData, setPrivacyData] = useState({
//     title: "",
//     imageKey: "",
//     content: "",
//   });
//   const [contactInfo, setContactInfo] = useState(null);
//   const [themeColors, setThemeColors] = useState({
//     color1: "",
//     color2: ""
//   });
//   const [loading, setLoading] = useState(true);

//   /* ================= LOAD DATA ================= */
//   useEffect(() => {
//     fetchPrivacyPolicy();
//     fetchContact();
//     fetchThemeColors();
//   }, []);

//   const fetchThemeColors = async () => {
//     try {
//       const res = await api.get("/sentinix/dashboardsettings");
//       if (res.data.success && res.data.data) {
//         const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
//         const latest = allData.sort((a, b) => b.id - a.id)[0];

//         if (latest) {
//           const color1 = latest.color1 || "";
//           const color2 = latest.color2 || "";
          
//           setThemeColors({ color1, color2 });
          
//           // Apply to CSS variables
//           document.documentElement.style.setProperty("--theme-color1", color1);
//           document.documentElement.style.setProperty("--theme-color2", color2);
//         }
//       }
//     } catch (err) {
//       console.error("Error fetching theme colors:", err);
//     }
//   };

//   const fetchPrivacyPolicy = async () => {
//     try {
//       const res = await api.get("/sentinix/dashboardsettings");
//       if (res.data.success && res.data.data) {
//         const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
//         const latest = allData.sort((a, b) => b.id - a.id)[0];

//         if (latest) {
//           setPrivacyData({
//             title: latest.title || "Privacy Policy",
//             imageKey: latest.imageKey || "",
//             content: latest.privacyPolicy || "",
//           });
//         }
//       }
//     } catch (err) {
//       console.error("Failed to load privacy policy:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchContact = async () => {
//     try {
//       const res = await api.get("/sentinix/contactforms");
//       if (res.data.success && res.data.data) {
//         const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
//         const info = allData.find((item) => item.title && item.Imagekey);
//         setContactInfo(info || null);
//       }
//     } catch (err) {
//       console.error("Failed to load contact info:", err);
//     }
//   };

//   /* ================= POLICY PARSER ================= */
//   const parsePolicyText = (text) => {
//     if (!text) return [];
//     const lines = text.split("\n");
//     const sections = [];
//     let current = null;

//     lines.forEach((line) => {
//       const trimmed = line.trim();
//       if (!trimmed) return;

//       const isHeading = /^(\d+[\.\)])\s+.+/.test(trimmed);
//       if (isHeading) {
//         if (current) sections.push(current);
//         current = { heading: trimmed, lines: [] };
//       } else {
//         if (!current) current = { heading: null, lines: [] };
//         current.lines.push(trimmed);
//       }
//     });

//     if (current) sections.push(current);
//     return sections;
//   };

//   const sections = parsePolicyText(privacyData.content);

//   return (
//     <>
//       <Navbar />

//       {/* ================= HERO BANNER ================= */}
//       <section className="contact-hero">
//         {privacyData.imageKey ? (
//           <img
//             className="contact-hero__img"
//             src={privacyData.imageKey}
//             alt={privacyData.title}
//           />
//         ) : (
//           <div className="service-hero-placeholder" />
//         )}

//         <div className="contact-hero__overlay">
//           <h1 className="contact-hero__title">{privacyData.title}</h1>
//         </div>
//       </section>

//       {/* ================= POLICY CONTENT ================= */}
//       <div className="pp-page">
//         <div className="pp-body">
//           {loading && (
//             <div className="pp-loading">
//               <div className="pp-spinner"></div>
//               <p>Loading Privacy Policy...</p>
//             </div>
//           )}

//           {!loading && privacyData.content && (
//             <div className="pp-sections">
//               {sections.length > 0 ? (
//                 sections.map((sec, idx) => (
//                   <div key={idx} className="pp-section-card fade-in">
//                     {sec.heading && (
//                       <div className="pp-section-header">
//                         <div className="pp-section-number">{idx + 0}</div>
//                         <h2 className="pp-section-title">
//                           {sec.heading.replace(/^\d+[\.\)]\s*/, "")}
//                         </h2>
//                       </div>
//                     )}
//                     <div className="pp-section-body">
//                       {sec.lines.map((line, i) => (
//                         <p key={i} className="pp-line">
//                           {line}
//                         </p>
//                       ))}
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="pp-section-card fade-in">
//                   <div className="pp-section-body">
//                     {privacyData.content.split("\n").map((line, i) => (
//                       <p key={i} className="pp-line">
//                         {line}
//                       </p>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}

//           {!loading && !privacyData.content && (
//             <div className="pp-empty">
//               <FaShieldAlt className="pp-empty-icon" />
//               <h3>Privacy Policy Coming Soon</h3>
//               <p>Please check back later.</p>
//             </div>
//           )}

//           {/* ================= CONTACT INFO ================= */}
//           <div className="pp-contact-section">
//             <h2 className="pp-contact-title">Contact Us</h2>

//             <div className="pp-contact-grid">
//               {contactInfo ? (
//                 <>
//                   {contactInfo.Address && (
//                     <div className="pp-contact-card">
//                       <FaMapMarkerAlt className="pp-contact-icon" />
//                       <p>{contactInfo.Address}</p>
//                     </div>
//                   )}
//                   {contactInfo.Email && (
//                     <div className="pp-contact-card">
//                       <FaEnvelope className="pp-contact-icon" />
//                       <p>{contactInfo.Email}</p>
//                     </div>
//                   )}
//                   {contactInfo.Phone && (
//                     <div className="pp-contact-card">
//                       <FaPhone className="pp-contact-icon" />
//                       <p>+91 {contactInfo.Phone}</p>
//                     </div>
//                   )}
//                 </>
//               ) : (
//                 <p>Contact information not available</p>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default PrivacyPolicy;

import React, { useState, useEffect } from "react";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaShieldAlt } from "react-icons/fa";
import "./PrivacyPolicy.css";
import Footer from "../pages/main/footer";
import Navbar from "../components/Navbar";
import api from "../services/httpService";

const PrivacyPolicy = () => {
  const [privacyData, setPrivacyData] = useState({
    title: "",
    imageKey: "",
    content: "",
  });
  const [contactInfo, setContactInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ================= LOAD DATA ================= */
  useEffect(() => {
    fetchPrivacyPolicy();
    fetchContact();
    fetchThemeColors();
  }, []);

  /* ================= THEME COLORS ================= */
  const fetchThemeColors = async () => {
    try {
      const res = await api.get("/sentinix/dashboardsettings");
      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data)
          ? res.data.data
          : [res.data.data];

        const latest = allData.sort((a, b) => b.id - a.id)[0];

        if (latest) {
          const color1 = latest.color1 || "#f83600";
          const color2 = latest.color2 || "#fe8c00";

          document.documentElement.style.setProperty("--theme-color1", color1);
          document.documentElement.style.setProperty("--theme-color2", color2);
        }
      }
    } catch (err) {
      console.error("Error fetching theme colors:", err);
    }
  };

  /* ================= PRIVACY POLICY ================= */
  const fetchPrivacyPolicy = async () => {
    try {
      const res = await api.get("/sentinix/dashboardsettings");
      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data)
          ? res.data.data
          : [res.data.data];

        const latest = allData.sort((a, b) => b.id - a.id)[0];

        if (latest) {
          setPrivacyData({
            title: latest.title || "Privacy Policy",
            imageKey: latest.imageKey || "",
            content: latest.privacyPolicy || "",
          });
        }
      }
    } catch (err) {
      console.error("Failed to load privacy policy:", err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= CONTACT ================= */
  const fetchContact = async () => {
    try {
      const res = await api.get("/sentinix/contactforms");
      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data)
          ? res.data.data
          : [res.data.data];

        const info = allData.find(
          (item) => item.title && item.Imagekey
        );
        setContactInfo(info || null);
      }
    } catch (err) {
      console.error("Failed to load contact info:", err);
    }
  };

  /* ================= POLICY PARSER ================= */
  const parsePolicyText = (text) => {
    if (!text) return [];
    const lines = text.split("\n");
    const sections = [];
    let current = null;

    lines.forEach((line) => {
      const trimmed = line.trim();
      if (!trimmed) return;

      const isHeading = /^(\d+[.)])\s+.+/.test(trimmed);

      if (isHeading) {
        if (current) sections.push(current);
        current = { heading: trimmed, lines: [] };
      } else {
        if (!current) current = { heading: null, lines: [] };
        current.lines.push(trimmed);
      }
    });

    if (current) sections.push(current);
    return sections;
  };

  const sections = parsePolicyText(privacyData.content);

  return (
    <>
      <Navbar />

      {/* ================= HERO ================= */}
      <section className="svc-hero">
        {privacyData.imageKey ? (
          <img
            className="svc-hero-img"
            src={privacyData.imageKey}
            alt={privacyData.title}
          />
        ) : (
          <div className="service-hero-placeholder" />
        )}

        {/* <div className="contact-hero__overlay">
          <h1 className="contact-hero__title">{privacyData.title}</h1>
        </div> */}
      </section>

      {/* ================= CONTENT ================= */}
      <div className="pp-page">
        <div className="pp-body">
          {loading && (
            <div className="pp-loading">
              <div className="pp-spinner"></div>
              <p>Loading Privacy Policy...</p>
            </div>
          )}

          {!loading && privacyData.content && (
            <div className="pp-sections">
              {sections.map((sec, idx) => (
                <div key={idx} className="pp-section-card fade-in">
                  {sec.heading && (
                    <div className="pp-section-header">
                      <div className="pp-section-number">{idx + 0}</div>
                      <h2 className="pp-section-title">
                        {sec.heading.replace(/^\d+[.)]\s*/, "")}
                      </h2>
                    </div>
                  )}
                  <div className="pp-section-body">
                    {sec.lines.map((line, i) => (
                      <p key={i} className="pp-line">{line}</p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {!loading && !privacyData.content && (
            <div className="pp-empty">
              <FaShieldAlt className="pp-empty-icon" />
              <h3>Privacy Policy Coming Soon</h3>
              <p>Please check back later.</p>
            </div>
          )}

          {/* ================= CONTACT ================= */}
          <div className="pp-contact-section">
            <h2 className="pp-contact-title">Contact Us</h2>

            <div className="pp-contact-grid">
              {contactInfo ? (
                <>
                  {contactInfo.Address && (
                    <div className="pp-contact-card">
                      <FaMapMarkerAlt className="pp-contact-icon" />
                      <p>{contactInfo.Address}</p>
                    </div>
                  )}
                  {contactInfo.Email && (
                    <div className="pp-contact-card">
                      <FaEnvelope className="pp-contact-icon" />
                      <p>{contactInfo.Email}</p>
                    </div>
                  )}
                  {contactInfo.Phone && (
                    <div className="pp-contact-card">
                      <FaPhone className="pp-contact-icon" />
                      <p>+91 {contactInfo.Phone}</p>
                    </div>
                  )}
                </>
              ) : (
                <p>Contact information not available</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;